import { FC } from "react";

const StorefrontTab: FC = () => {
  return (
    <div>
      <h2>Setup Storefront List & Search Brand</h2>
      <p>Placeholder for storefront functionality</p>
    </div>
  );
};

export default StorefrontTab;
